import React from 'react'
import Swal from 'sweetalert2'
import Constant from '../../Constant'
import axios from 'axios'
import Toggle from 'react-toggle'
import Select from 'react-select'
import ImageCropper from '../../common/ImageCropper/ImageCropper'
import ReactQuill from 'react-quill'

class AdsAdd extends React.Component {
  state = {
    status: 'AVAILABLE',
    order: null,
    country_data: [],
    title_en: '',
    title_ar: '',
    image_en: '',
    image_ar: '',
    description_en: '',
    description_ar: '',
    id: '',
    states_data: [],
    link_types: [
      { id: 'EL', name: 'External' },
      { id: 'CP', name: 'Coupons' },
      { id: 'LC', name: 'Location' },
      { id: 'IN', name: 'Internal' },
    ],
    internal_link_types: [
      { id: 'CH', name: 'Chalet Details' },
      { id: 'CHL', name: 'Chalet List' },
      { id: 'Y', name: 'Cruise' },
      { id: 'T', name: 'Trips(Cruise)' },
      { id: 'O', name: 'Event' },
      { id: 'A', name: 'Activity' },
      { id: 'S', name: 'Stores' },
      { id: 'OF', name: 'Flash Offer' },
      { id: 'CT', name: 'Cruise Trip' },
    ],
    link_type: '',
    internal_link_type: '',
    link_option: {},
    link_option_value: '',
    link_options: [],
    is_active: false,
    lat: '',
    long: '',
    categoryList: [],
    companyList: [],
    category_id: '',
    company_id: '',
    isSaving: false,

    only_image: false,
  }

  handleChange = (event) => {
    if (event.target.name == 'only_image') {
      this.setState({
        [event.target.name]: event.target.checked,
        title_en: '',
        title_ar: '',
        description_en: '',
        description_ar: '',
        image_en: '',
        image_ar: '',
      })
    } else if (event.target.name == 'is_active') {
      this.setState({ is_active: event.target.checked })
    } else {
      this.setState({ [event.target.name]: event.target.value })
    }

    if (event.target.name == 'link_type' || event.target.name == 'internal_link_type') {
      if (event.target.name == 'internal_link_type' && event.target.value != 'CHL') {
        const link_type = { link_type: event.target.value || '' }
        this.getLinkTypeOptions(link_type)
      }

      if (event.target.name == 'link_type') {
        this.setState({
          internal_link_type: '',
        })
      }

      this.setState({
        category_id: null,
        company_id: null,
        link_option: null,
        lat: '',
        long: '',
        link_option_value: '',
      })
    }

    if (event.target.name === 'internal_link_type') {
      if (event.target.value === 'O') {
        this.loadCategories('EVENT')
      } else if (event.target.value === 'A') {
        this.loadCategories('ACTIVITY')
      }
    }

    if (event.target.name == 'category_id') {
      this.setState({ companyList: [], link_options: [] })
      const catData = this.state.categoryList.find((ele) => ele.id === event.target.value)
      if (catData) {
        this.loadCompanyData(catData.category_type, catData.id)
      }

      this.setState({
        company_id: '',
        link_option: '',
      })
    }

    if (event.target.name == 'company_id') {
      let data = {
        link_type: this.state.internal_link_type,
      }
      if (event.target.value) {
        data = {
          ...data,
          category_id: this.state.category_id,
          company_id: event.target.value,
        }
        this.getLinkTypeOptions(data)
      } else {
        this.getLinkTypeOptions(data)
      }

      this.setState({
        link_option: '',
      })
    }
  }

  componentDidMount() {
    const id = this.props.id
    if (id) {
      this.setState(
        {
          Edit: true,
          Edit1: true,
          id: id,
        },
        () => {
          this.getUpdateData(id)
        }
      )
    }
  }

  getUpdateData = async (id) => {
    await axios
      .get(Constant.getAPI() + `/ads/details?id=${id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then(async (res) => {
        if (res.status === 200) {
          const data = res.data.data

          let linkData = { link_type: data.internal_link_type }

          if (data.link_type == 'CP') {
            linkData = { link_type: data.link_type }
          }

          if (data.category_id && data.company_id) {
            linkData.category_id = data.category_id
            linkData.company_id = data.company_id
          }

          await this.getLinkTypeOptions(linkData)

          this.setState(
            {
              title_en: data.title_en,
              title_ar: data.title_ar,
              description_en: data.description_en,
              description_ar: data.description_ar,
              link_type: data.link_type,
              internal_link_type: data.internal_link_type,
              link_option: this.state.link_options?.find((ele) => ele.value === data.type_id),
              link_option_value: data.value,
              lat: data.lat,
              long: data.long,
              is_active: data.is_active,
              image_en: data.image_en,
              image_ar: data.image_ar,
              category_id: data.category_id,
              company_id: data.company_id,
              order: data.order,

              only_image: !data.title_en && !data.title_ar && !data.description_ar && !data.description_en,
            },
            () => {
              if (data.internal_link_type === 'O') {
                this.loadCategories('EVENT')
              } else if (data.internal_link_type === 'A') {
                this.loadCategories('ACTIVITY')
              }
            }
          )
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  onSaveData = () => {
    if (this.state.internal_link_type === 'E' && !this.state.company_id && !this.state.link_option?.value) {
      Swal.fire({
        title: 'Please select event or event company',
        icon: 'error',
        text: "The value in this field can't be empty",
        type: 'error',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok',
      })
      return false
    }

    const formData = new FormData()

    formData.append('title_en', this.state.title_en)
    formData.append('title_ar', this.state.title_ar)
    formData.append('description_en', this.state.description_en)
    formData.append('description_ar', this.state.description_ar)

    formData.append('link_type', this.state.link_type)
    formData.append('type_id', this.state?.link_option?.value || '')
    formData.append('company_id', this.state?.company_id)
    formData.append('category_id', this.state?.category_id)
    formData.append('value', this.state.link_option_value)
    formData.append('lat', this.state.lat)
    formData.append('long', this.state.long)
    formData.append('is_active', this.state.is_active)
    formData.append('only_image', this.state.only_image)
    formData.append('order', this.state.order)

    if (this.state.internal_link_type) {
      formData.append('internal_link_type', this.state.internal_link_type)
    }
    if (this.state.image_en?.type) {
      formData.append('image_en', this.state.image_en, 'your_original_filename.jpeg')
    }
    if (this.state.image_ar?.type) {
      formData.append('image_ar', this.state.image_ar, 'your_original_filename.jpeg')
    }

    this.setState({ isSaving: true })

    if (this.props.id) {
      const id = this.props.id
      formData.append('id', id)

      axios
        .post(Constant.getAPI() + '/ads/update-ad', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
            country_short_name: `${localStorage.getItem('countryShortName')}`,
          },
        })
        .then((res) => {
          this.setState({ isSaving: false })
          if (res.status) {
            Swal.fire({
              title: 'Item Updated Successfully!',
              icon: 'success',
              text: '',
              type: 'success',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
          window.location.href = `#/ads`
        })
        .catch((err) => {
          this.setState({ isSaving: false })
          if (err?.response?.status === 401) {
            Constant.getAuthLogout()
          } else {
            Swal.fire({
              title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
              icon: 'error',
              text: '',
              type: 'error',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
        })
    } else {
      axios
        .post(Constant.getAPI() + '/ads/create-ad', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
            country_short_name: `${localStorage.getItem('countryShortName')}`,
          },
        })
        .then((res) => {
          this.setState({ isSaving: false })
          if (res.status) {
            Swal.fire({
              title: 'Item Added Successfully!',
              icon: 'success',
              text: '',
              type: 'success',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
          window.location.href = `#/ads`
        })
        .catch((err) => {
          this.setState({ isSaving: false })
          if (err?.response?.status === 401) {
            Constant.getAuthLogout()
          } else {
            Swal.fire({
              title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
              icon: 'error',
              text: '',
              type: 'error',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
        })
    }
  }

  handleChangeImage = (e, imgKeyName) => {
    this.setState({
      [imgKeyName]: e,
      Edit: false,
    })

    if (imgKeyName == 'image_en') {
      this.setState({ img: URL.createObjectURL(e) })
    } else {
      this.setState({ img1: URL.createObjectURL(e) })
    }
  }

  getLinkTypeOptions = async (data) => {
    this.setState({
      link_options: [],
      link_option: null,
    })

    var that = this
    await axios
      .post(Constant.getAPI() + '/ads/link-data', data, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (data.link_type == 'CP') {
          that.setState({
            link_options: res.data.data.map((itm) => ({
              label: `${itm.coupon_code} (Name - ${itm.coupon_name})`,
              value: itm.id,
            })),
          })
        } else {
          that.setState({
            link_options: res.data.data.map((itm) => ({ label: itm.name_en + ' \\ ' + itm.name_ar, value: itm.id })),
          })
        }
      })
      .catch((err) => {
        // eslint-disable-next-line
        console.log('Error while getting link types', err)
      })
  }

  handleSelectCoupon = (event) => {
    this.setState({ link_option: event })
  }

  handleClear = () => {
    this.setState({ link_option: null })
  }

  loadCategories = async (type) => {
    this.setState({
      categoryList: [],
      companyList: [],
    })
    await axios
      .get(Constant.getAPI() + `/event-categories/categories-v2/${type}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data?.success) {
          this.setState(
            {
              categoryList: res.data?.data,
            },
            () => {
              if (this.props.id) {
                const catData = this.state.categoryList.find((ele) => ele.id === this.state.category_id)
                if (catData) {
                  this.loadCompanyData(catData.category_type, catData.id)
                }
              }
            }
          )
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  loadCompanyData = async (type, id) => {
    if (id) {
      await axios
        .get(Constant.getAPI() + `/event-companies/list-event-companies-v2/${type}/${id}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
            country_short_name: `${localStorage.getItem('countryShortName')}`,
          },
        })
        .then((res) => {
          if (res.data?.success) {
            this.setState({
              companyList: res.data?.data,
            })
          }
        })
        .catch((err) => {
          if (err?.response?.status === 401) {
            Constant.getAuthLogout()
          } else {
            Swal.fire({
              title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
              icon: 'error',
              text: '',
              type: 'error',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
        })
    }
  }

  render() {
    return (
      <div className="">
        <div className="card-body">
          <div className="row">
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Link Type</label>
                <div className="col-sm-9">
                  <select
                    name="link_type"
                    className="form-control form-control-inverse"
                    onChange={this.handleChange}
                    value={this.state.link_type}
                  >
                    <option value="">Select Type</option>
                    {this.state.link_types.map((data, i) => (
                      <option
                        value={data.id}
                        key={i}
                      >
                        {data.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
            {this.state.link_type == 'IN' && (
              <div className="col-md-6">
                <div className="form-group row">
                  <label className="col-sm-3 col-form-label">Internal Link Type</label>
                  <div className="col-sm-9">
                    <select
                      name="internal_link_type"
                      className="form-control form-control-inverse"
                      onChange={this.handleChange}
                      value={this.state.internal_link_type}
                    >
                      <option value="">Select Type</option>
                      {this.state.internal_link_types.map((data, i) => (
                        <option
                          value={data.id}
                          key={i}
                        >
                          {data.name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
            )}
            {this.state.link_type == 'IN' &&
              (this.state.internal_link_type === 'O' || this.state.internal_link_type === 'A') && (
                <div className="col-md-6">
                  <div className="form-group row">
                    <label className="col-sm-3 col-form-label">Event Category</label>
                    <div className="col-sm-9">
                      <select
                        name="category_id"
                        className="form-control form-control-inverse"
                        onChange={this.handleChange}
                        value={this.state.category_id}
                      >
                        <option value="">Select Type</option>
                        {this.state.categoryList.map((data, i) => (
                          <option
                            value={data.id}
                            key={i}
                          >
                            {data.category_name_en}/{data.category_name_ar}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
              )}
            {this.state.link_type == 'IN' &&
              (this.state.internal_link_type === 'O' || this.state.internal_link_type === 'A') && (
                <div className="col-md-6">
                  <div className="form-group row">
                    <label className="col-sm-3 col-form-label">Event Company</label>
                    <div className="col-sm-9">
                      <select
                        name="company_id"
                        className="form-control form-control-inverse"
                        onChange={this.handleChange}
                        value={this.state.company_id}
                      >
                        <option value="">Select Type</option>
                        {this.state.companyList.map((data, i) => (
                          <option
                            value={data.id}
                            key={i}
                          >
                            {data.company_name}/{data.company_short_name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
              )}
            {((this.state.link_type == 'IN' &&
              this.state.internal_link_type != 'CHL' &&
              this.state.internal_link_type != 'T') ||
              this.state.link_type == 'CP') && (
                <div className="col-md-6">
                  <div className="form-group row">
                    <label className="col-sm-3 col-form-label">Link Options</label>
                    <div className="col-sm-9">
                      <Select
                        name="link_option"
                        value={this.state.link_option}
                        onChange={this.handleSelectCoupon}
                        options={this.state.link_options}
                        isMulti={false}
                        isSearchable={true}
                        isClearable
                        onClear={this.handleClear}
                        placeholder="Select Options"
                      />
                    </div>
                  </div>
                </div>
              )}
            {this.state.link_type == 'LC' && (
              <>
                <div className="col-md-6">
                  <div className="form-group row">
                    <label className="col-sm-3 col-form-label">Latitude</label>
                    <div className="col-sm-9">
                      <input
                        type="text"
                        className="form-control"
                        name="lat"
                        id="lat"
                        placeholder="Latitude"
                        onChange={this.handleChange}
                        value={this.state.lat}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group row">
                    <label className="col-sm-3 col-form-label">Longitude</label>
                    <div className="col-sm-9">
                      <input
                        type="text"
                        className="form-control"
                        name="long"
                        id="long"
                        placeholder="Longitude"
                        onChange={this.handleChange}
                        value={this.state.long}
                      />
                    </div>
                  </div>
                </div>
              </>
            )}
            {this.state.link_type == 'EL' && (
              <div className="col-md-6">
                <div className="form-group row">
                  <label className="col-sm-3 col-form-label">External Link</label>
                  <div className="col-sm-9">
                    <input
                      type="text"
                      className="form-control"
                      name="link_option_value"
                      id="link_option_value"
                      placeholder="External Link"
                      onChange={this.handleChange}
                      value={this.state.link_option_value}
                    />
                  </div>
                </div>
              </div>
            )}
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Order</label>
                <div className="col-sm-9">
                  <input
                    type="number"
                    className="form-control"
                    name="order"
                    id="order"
                    placeholder="Enter number"
                    onChange={this.handleChange}
                    value={this.state.order}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Is Active</label>
                <div className="col-sm-9">
                  <Toggle
                    className="ml-2 form-control"
                    name="is_active"
                    id="is_active"
                    onChange={this.handleChange}
                    checked={this.state.is_active}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Only Image</label>
                <div className="col-sm-9">
                  <Toggle
                    className="ml-2 form-control"
                    name="only_image"
                    id="only_image"
                    onChange={this.handleChange}
                    checked={this.state.only_image}
                  />
                </div>
              </div>
            </div>
            <div
              className="col-md-12"
              style={{ borderTop: '2px solid #eee', marginBottom: 20 }}
            ></div>
            {this.state.only_image ? null : (
              <>
                <div className="col-md-6">
                  <div className="form-group row">
                    <label className="col-sm-3 col-form-label">Title En</label>
                    <div className="col-sm-9">
                      <input
                        type="text"
                        className="form-control"
                        name="title_en"
                        id="title_en"
                        placeholder="Title En"
                        onChange={this.handleChange}
                        value={this.state.title_en}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group row">
                    <label className="col-sm-3 col-form-label">Title AR</label>
                    <div className="col-sm-9">
                      <input
                        type="text"
                        className="form-control"
                        name="title_ar"
                        id="title_ar"
                        placeholder="Title Ar"
                        onChange={this.handleChange}
                        value={this.state.title_ar}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group row">
                    <label className="col-sm-3 col-form-label">Description En</label>
                    <div className="col-sm-9">
                      <ReactQuill
                        name="description_en"
                        id="description_en"
                        value={this.state.description_en}
                        onChange={(value) => {
                          this.setState({
                            description_en: value,
                          })
                        }}
                        placeholder="Description En"
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group row">
                    <label className="col-sm-3 col-form-label">Description Ar</label>
                    <div className="col-sm-9">
                      <ReactQuill
                        name="description_ar"
                        id="description_ar"
                        value={this.state.description_ar}
                        onChange={(value) => {
                          this.setState({
                            description_ar: value,
                          })
                        }}
                        placeholder="Description Ar"
                      />
                    </div>
                  </div>
                </div>
                <div
                  className="col-md-12"
                  style={{ borderTop: '2px solid #eee', marginBottom: 20 }}
                ></div>
              </>
            )}
            <div className="col-md-6">
              <div className="row">
                <div className="col-sm-3">Image English</div>
                <div className="col-sm-6">
                  {this.state.only_image ? (
                    <div style={{ color: 'red' }}>Image height width must be 137:180 ratio or 685 x 900</div>
                  ) : (
                    <div style={{ color: 'red' }}>Image height width must be 26:19 ratio or 520 * 380</div>
                  )}
                  <ImageCropper
                    ratio={this.state.only_image ? 137 / 180 : 26 / 19}
                    img={this.state.image_en || null}
                    onChange={(e) => {
                      this.handleChangeImage(e, 'image_en')
                    }}
                  ></ImageCropper>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="row">
                <div className="col-sm-3">Image Arabic</div>
                <div className="col-sm-6">
                  {this.state.only_image ? (
                    <div style={{ color: 'red' }}>Image height width must be 137:180 ratio or 685 x 900</div>
                  ) : (
                    <div style={{ color: 'red' }}>Image height width must be 26:19 ratio or 520 * 380</div>
                  )}
                  <ImageCropper
                    ratio={this.state.only_image ? 137 / 180 : 26 / 19}
                    img={this.state.image_ar || null}
                    onChange={(e) => {
                      this.handleChangeImage(e, 'image_ar')
                    }}
                  ></ImageCropper>
                </div>
              </div>
            </div>
          </div>
          <div className="row float-right p-3">
            {this.state.isSaving ? (
              <button
                className="btn btn-grd-disabled mr-2"
                disabled
              >
                Saving...!
              </button>
            ) : (
              <button
                onClick={this.onSaveData}
                className="btn hor-grd btn-grd-inverse"
              >
                <i className="icofont icofont-save"></i> Save
              </button>
            )}
          </div>
        </div>
      </div>
    )
  }
}

export default AdsAdd
